import { useState } from 'react';
import axios from 'axios';
import { Calendar } from 'lucide-react';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function CallbackScheduler({ contactId, campaignId, onScheduled }) {
  const [scheduledTime, setScheduledTime] = useState('');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSchedule = async (e) => {
    e.preventDefault();
    if (!scheduledTime) return;

    setLoading(true);
    try {
      const token = localStorage.getItem('accessToken');
      await axios.post(
        `${API_BASE}/dialer/callbacks`,
        {
          contact_id: contactId,
          campaign_id: campaignId,
          scheduled_time: scheduledTime,
          reason
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      onScheduled?.();
      setScheduledTime('');
      setReason('');
    } catch (error) {
      console.error('Error scheduling callback:', error);
      alert('Failed to schedule callback');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSchedule} className="space-y-3">
      <div>
        <label className="block text-sm font-medium mb-1">Schedule Callback</label>
        <input
          type="datetime-local"
          value={scheduledTime}
          onChange={(e) => setScheduledTime(e.target.value)}
          className="w-full border rounded px-3 py-2"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium mb-1">Reason (optional)</label>
        <textarea
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          className="w-full border rounded px-3 py-2"
          rows={2}
          placeholder="Why is a callback needed?"
        />
      </div>
      <button
        type="submit"
        disabled={!scheduledTime || loading}
        className="w-full bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700 disabled:bg-gray-400 flex items-center justify-center gap-2"
      >
        <Calendar className="w-4 h-4" />
        {loading ? 'Scheduling...' : 'Schedule Callback'}
      </button>
    </form>
  );
}


